import { API_BASE_URL } from '../config/api';
import { CusTomTimelineRow } from '../components/timeline/mock.ts';
import { buildStitchSegments } from '../components/timeline/timelineUtils.ts';

export const getAudioBlob = async (
  data: CusTomTimelineRow[],
  videoId: string = '123',
  token: string | null
): Promise<Blob> => {
  try {
    if (!token) {
      return new Blob();
    }

    const audioSegments = buildStitchSegments(data);

    if (audioSegments.length === 0) {
      throw new Error('No stitchable segments found in the data');
    }

    const response = await fetch(
      `${API_BASE_URL}/audio/stitchAudio`,
      {
        method: 'POST',
        headers: {
          Authorization: token,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          videoId,
          segments: audioSegments,
        }),
      }
    );

    if (!response.ok) {
      throw new Error(`API request failed with status ${response.status}`);
    }

    const responseData = await response.json();

    if (!responseData || !responseData.downloadUrl) {
      throw new Error('No download URL in the response');
    }

    const audioResponse = await fetch(responseData.downloadUrl);

    if (!audioResponse.ok) {
      throw new Error(
        `Failed to download audio with status ${audioResponse.status}`
      );
    }

    return await audioResponse.blob();
  } catch (error) {
    console.error('Error getting audio blob:', error);
    throw error;
  }
};
